import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { APIService, AuthService } from '../services';

@Component({
  templateUrl: 'login.component.html',
  providers: [APIService]
})
export class LoginComponent {
    code: string;
    errorMessage: string;

    constructor(
        private apiService: APIService,
        private authService: AuthService,
        private router: Router
    ) {}

    login(): void {
        this.apiService.login(this.code).subscribe(
            response => {
                if(response.key) {
                    this.authService.authKey = response.key;
                    this.router.navigate(['/control']);
                } else {
                    this.errorMessage = 'error';
                }
            },
            error => this.errorMessage = 'error'
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts